(function () {
  var STORAGE_KEY = 'meemee_delivery_pincode';
  var MUMBAI_ZONE = 'mumbai';
  var BUILD_YOUR_OWN_HIDDEN_ZONES = ['pune', 'bangalore', 'bengaluru'];
  var BUILD_YOUR_OWN_HANDLE = 'make-your-own-hamper';
  var BUILD_YOUR_OWN_SLUG = 'build-your-own';
  var RESTRICTED_BUNDLE_PRODUCTS = [
    {
      handles: [BUILD_YOUR_OWN_HANDLE, BUILD_YOUR_OWN_SLUG],
      titleTerms: ['build your own'],
      hideMenuLink: true,
      redirectTo: '/'
    },
    {
      handles: ['assorted-toasties'],
      titleTerms: ['assorted toasties'],
      hideMenuLink: false,
      redirectTo: '/collections/toasties'
    }
  ];

  function normalizePincode(v) {
    return String(v || '').replace(/\D/g, '').slice(0, 6);
  }

  function normalizeText(v) {
    return String(v || '').trim().toLowerCase();
  }

  function getStoredPincode() {
    try {
      return normalizePincode(localStorage.getItem(STORAGE_KEY));
    } catch (e) {}
    var m = document.cookie.match(/(?:^|; )meemee_delivery_pincode=([^;]*)/);
    return m ? normalizePincode(decodeURIComponent(m[1])) : '';
  }

  function parseGlobalZones() {
    var el = document.getElementById('meemee-global-zones');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent).map(function (z) {
        return {
          title: String(z.title || '').trim(),
          key: normalizeText(z.title),
          pincodes: String(z.pincodes || '').split(/[\s,]+/).map(normalizePincode).filter(Boolean),
          variantIds: (z.variant_ids || []).map(String)
        };
      });
    } catch (e) {
      return [];
    }
  }

  function getZoneForPincode(zones, pincode) {
    if (!pincode || pincode.length !== 6) return null;
    return zones.find(function (zone) {
      return zone.pincodes.indexOf(pincode) !== -1;
    }) || null;
  }

  function isServiceable(zones, pincode, variantId) {
    var vid = String(variantId);
    return zones.some(function (z) {
      return z.pincodes.indexOf(pincode) !== -1 && z.variantIds.indexOf(vid) !== -1;
    });
  }

  function isMumbaiZone(zone) {
    return zone && zone.key.indexOf(MUMBAI_ZONE) !== -1;
  }

  function shouldHideBuildYourOwn(zone) {
    return !!zone && BUILD_YOUR_OWN_HIDDEN_ZONES.some(function (hiddenZone) {
      return zone.key.indexOf(hiddenZone) !== -1;
    });
  }

  function applyCard(card, zones, pincode) {
    var hasPincode = pincode && pincode.length === 6;

    // A2C visibility is driven entirely by the CSS class on the card.
    // CSS rule in <head>: .product-block:not(.pc-a2c-visible) [data-add-to-cart] { display:none !important }
    if (!hasPincode) {
      card.classList.remove('pc-a2c-visible');
      return;
    }

    var productJsonEl = card.querySelector('[data-product-json]');
    var productData = null;
    try { productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch (e) {}
    var variants = (productData && productData.variants) || [];

    // Hide option buttons where no variant with that option value is serviceable
    var form = card.querySelector('form') || card;
    form.querySelectorAll('[data-single-option-selector][data-selector-type="listed"]').forEach(function (fieldset) {
      var optionProp = fieldset.dataset.index;
      fieldset.querySelectorAll('input.js-option').forEach(function (input) {
        var anyServiceable = variants.some(function (v) {
          return v[optionProp] === input.value && isServiceable(zones, pincode, v.id);
        });
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        input.style.setProperty('display', anyServiceable ? '' : 'none', 'important');
        input.disabled = !anyServiceable;
        if (label) label.style.setProperty('display', anyServiceable ? '' : 'none', 'important');
      });
    });

    var anyServiceable = variants.some(function (v) {
      return isServiceable(zones, pincode, v.id);
    });

    card.classList.toggle('pc-a2c-visible', anyServiceable);
  }

  function applyCartDrawer(zone) {
    var hasKnownZone = !!zone;
    var showDatePicker = isMumbaiZone(zone);

    document.querySelectorAll('#CartDrawer-Checkout, [name="checkout"].cart__checkout-button, input[name="checkout"].cart-submit').forEach(function (checkoutButton) {
      checkoutButton.style.display = hasKnownZone ? '' : 'none';
      checkoutButton.disabled = !hasKnownZone;
      checkoutButton.setAttribute('aria-hidden', hasKnownZone ? 'false' : 'true');
    });

    document.querySelectorAll('.date-box-wrap').forEach(function (dateWrap) {
      var dateInput = dateWrap.querySelector('input[name="attributes[delivery-date]"], #date');

      dateWrap.style.display = showDatePicker ? '' : 'none';
      dateWrap.setAttribute('aria-hidden', showDatePicker ? 'false' : 'true');

      if (!showDatePicker && dateInput && dateInput.value) {
        dateInput.value = '';
        if (typeof window.updateCartAttribute === 'function') {
          window.updateCartAttribute('delivery-date', '');
        }
      }
    });

    document.documentElement.classList.toggle('meemee-has-delivery-zone', hasKnownZone);
    document.documentElement.classList.toggle('meemee-zone-mumbai', showDatePicker);
  }

  function matchesRestrictedRuleByText(haystack, terms) {
    return terms.some(function (term) {
      return haystack.indexOf(term) !== -1;
    });
  }

  function matchesRestrictedRuleByHandle(haystack, handles) {
    return handles.some(function (handle) {
      return handle && haystack.indexOf(handle) !== -1;
    });
  }

  function getRestrictedBundleRuleFromCard(card) {
    var handle = normalizeText(card.dataset.productHandle);
    var titleLink = card.querySelector('.product-block__title-link');
    var titleText = titleLink ? normalizeText(titleLink.textContent) : '';
    var cardLinks = Array.prototype.slice.call(card.querySelectorAll('a[href]'));

    return RESTRICTED_BUNDLE_PRODUCTS.find(function (rule) {
      var handleMatch = matchesRestrictedRuleByHandle(handle, rule.handles);
      var titleMatch = matchesRestrictedRuleByText(titleText, rule.titleTerms);
      var linkMatch = cardLinks.some(function (link) {
        return matchesRestrictedRuleByHandle(normalizeText(link.getAttribute('href')), rule.handles);
      });

      return handleMatch || titleMatch || linkMatch;
    });
  }

  function getRestrictedBundleRuleFromLink(link) {
    var href = normalizeText(link.getAttribute('href'));
    var text = normalizeText(link.textContent);

    return RESTRICTED_BUNDLE_PRODUCTS.find(function (rule) {
      return rule.hideMenuLink && (
        matchesRestrictedRuleByHandle(href, rule.handles) ||
        matchesRestrictedRuleByText(text, rule.titleTerms)
      );
    });
  }

  function applyRestrictedBundleVisibility(zone) {
    var hideRestrictedBundles = shouldHideBuildYourOwn(zone);

    document.querySelectorAll('.product-block').forEach(function (card) {
      var restrictedRule = getRestrictedBundleRuleFromCard(card);
      card.style.display = hideRestrictedBundles && restrictedRule ? 'none' : '';
    });

    document.querySelectorAll('.header-navigation a, .site-header a, .bottom-menu a').forEach(function (link) {
      if (!getRestrictedBundleRuleFromLink(link)) return;

      var item = link.closest('li');
      if (item && !item.closest('.product-block')) {
        item.style.display = hideRestrictedBundles ? 'none' : '';
      }
    });
  }

  function applyRestrictedBundleRedirect(zone) {
    if (!shouldHideBuildYourOwn(zone)) return;

    var currentPath = normalizeText(window.location.pathname);
    var redirectRule = RESTRICTED_BUNDLE_PRODUCTS.find(function (rule) {
      return rule.handles.some(function (handle) {
        return handle && currentPath.indexOf('/products/' + handle) !== -1;
      });
    });

    if (redirectRule && redirectRule.redirectTo && currentPath !== redirectRule.redirectTo) {
      window.location.replace(redirectRule.redirectTo);
    }
  }

  function applyAll(zones, pincode) {
    var zone = getZoneForPincode(zones, pincode);

    document.querySelectorAll('.product-block').forEach(function (card) {
      applyCard(card, zones, pincode);
    });

    applyCartDrawer(zone);
    applyRestrictedBundleVisibility(zone);
    applyRestrictedBundleRedirect(zone);
  }

  function init() {
    var zones = parseGlobalZones();
    var currentPincode = getStoredPincode();

    applyAll(zones, currentPincode);

    window.addEventListener('meemee:pincode-updated', function (e) {
      currentPincode = e.detail && e.detail.pincode ? normalizePincode(e.detail.pincode) : getStoredPincode();
      applyAll(zones, currentPincode);
    });

    // Intercept fetch to catch cart and product-card section re-renders.
    var origFetch = window.fetch;
    window.fetch = function () {
      var promise = origFetch.apply(this, arguments);
      promise.then(function () {
        Promise.resolve().then(function () {
          applyAll(zones, currentPincode || getStoredPincode());
        });
      });
      return promise;
    };

    // Also cover any dynamically added cards/drawer markup via MutationObserver.
    var mutationTimer = null;
    var pendingCards = new Set();
    var shouldApplyGlobal = false;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var target = mutation.target;
        var parentCard = target.closest ? target.closest('.product-block') : null;
        if (parentCard) pendingCards.add(parentCard);
        if (
          target.closest &&
          (target.closest('cart-drawer') || target.closest('.drawer__footer') || target.closest('.header-navigation') || target.closest('.site-header'))
        ) {
          shouldApplyGlobal = true;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('product-block')) pendingCards.add(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('.product-block').forEach(function (c) { pendingCards.add(c); });
          }
          var nearestCard = node.closest ? node.closest('.product-block') : null;
          if (nearestCard) pendingCards.add(nearestCard);

          if (
            (node.matches && (node.matches('cart-drawer, .drawer__footer, .date-box-wrap, #CartDrawer-Checkout, .header-navigation, .site-header'))) ||
            (node.querySelector && node.querySelector('cart-drawer, .drawer__footer, .date-box-wrap, #CartDrawer-Checkout, .header-navigation, .site-header'))
          ) {
            shouldApplyGlobal = true;
          }
        });
      });

      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(function () {
        var pincode = currentPincode || getStoredPincode();
        var zone = getZoneForPincode(zones, pincode);
        var hadPendingCards = pendingCards.size > 0;

        pendingCards.forEach(function (card) { applyCard(card, zones, pincode); });
        pendingCards.clear();

        if (hadPendingCards || shouldApplyGlobal) {
          applyCartDrawer(zone);
          applyRestrictedBundleVisibility(zone);
          applyRestrictedBundleRedirect(zone);
          shouldApplyGlobal = false;
        }
      }, 0);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
